import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NflHotPlayersRow from "../../components/home/NflHotPlayersRow";
import NflAllTimeGreatsEntry from "../../components/home/NflAllTimeGreatsEntry";
import NflTeamsRow from "../../components/home/NflTeamsRow";
import TriviaChallenge from "../../components/home/TriviaChallenge";
import TodaysDebateSection from "../../components/community/TodaysDebateHero";
import CommunityModule from "../../components/home/CommunityModule";
import { colors } from "../../theme";
import {
  BRAND_COLORS,
  brandOutlinedButtonSx,
  brandRgba,
} from "../../utils/brandAssets";
import {
  NFL_COMPARE_PRESETS,
  getNflComparePath,
} from "../../adapters/nflPlayerAdapter";

const NflHome = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 1200, mx: "auto" }}>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ letterSpacing: "0.16em" }}
        >
          stats.fan / NFL
        </Typography>
        <Typography variant="h3" component="h1" fontWeight={800} sx={{ mt: 0.5 }}>
          Football stats hub
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 1, maxWidth: 560 }}
        >
          23,410 players ingested from the Pro Football Archives — search, explore
          career leaders, and dive into all-time greats.
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            onClick={() => navigate("/app/nfl/players")}
            sx={brandOutlinedButtonSx}
          >
            Search players
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/app/nfl/teams")}
            sx={brandOutlinedButtonSx}
          >
            Browse teams
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/app/nfl/queryBuilder")}
            sx={brandOutlinedButtonSx}
          >
            Stat Explorer
          </Button>
        </Box>
      </Box>

      <TriviaChallenge sport="nfl" />
      <TodaysDebateSection sport="nfl" />
      <CommunityModule sport="nfl" />
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
          Compare players
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {NFL_COMPARE_PRESETS.map((preset) => (
            <Chip
              key={preset.label}
              label={preset.label}
              clickable
              variant="outlined"
              onClick={() => navigate(getNflComparePath(preset.players))}
              sx={{
                borderColor: colors.border,
                "&:hover": {
                  borderColor: BRAND_COLORS.cyan,
                  backgroundColor: brandRgba(BRAND_COLORS.cyan, 0.08),
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <NflTeamsRow />
      <NflHotPlayersRow />
      <NflAllTimeGreatsEntry />
    </Box>
  );
};

export default NflHome;
